<div class="modal-body p-3 p-md-4">

  <div class="d-flex align-items-start justify-content-between mb-3">
    <p class="fs-normal fw-800 color-gray-950 mb-0">{{'planner.add_topic'|translate}}</p>
    <a class="clickable color-gray-400 ms-2" (click)="modal.dismiss()" [ngbTooltip]="'buttons.close'|translate" container="body"><i class="bi bi-x-lg"></i></a>
  </div>

  <div class="mode-switch d-flex mb-3">
    <a class="mode-option flex-fill text-center fs-small fw-800 clickable py-1"
       [class.active]="mode === 'topic'" (click)="setMode('topic')">
      {{'planner.mode_topic'|translate}}
    </a>
    <a class="mode-option flex-fill text-center fs-small fw-800 clickable py-1"
       [class.active]="mode === 'text'" (click)="setMode('text')">
      {{'planner.mode_text'|translate}}
    </a>
  </div>

  <form [formGroup]="fg" (ngSubmit)="onSubmit()">

    <ng-container *ngIf="mode === 'topic'">
      <label class="fs-small fw-500 color-gray-500 mb-1">{{'planner.exam'|translate}}</label>
      <app-gray-select-input
        [items]="exams" bindValue="id" bindLabel="name" [clearable]="false"
        [hasError]="isSubmitted && fg.get('examId')?.invalid"
        [placeholder]="'planner.exam'|translate"
        formControlName="examId" (changed)="onExamChanged($event)"></app-gray-select-input>

      <label class="fs-small fw-500 color-gray-500 mb-1 mt-3">{{'planner.lesson'|translate}}</label>
      <app-gray-select-input
        [items]="lessons" bindValue="id" bindLabel="name" [clearable]="false" [searchable]="true"
        [hasError]="isSubmitted && fg.get('lessonId')?.invalid"
        [placeholder]="'planner.lesson'|translate"
        formControlName="lessonId" (changed)="onLessonChanged($event)"></app-gray-select-input>

      <label class="fs-small fw-500 color-gray-500 mb-1 mt-3">{{'planner.topic'|translate}}</label>
      <app-gray-select-input
        [items]="topics" bindValue="id" bindLabel="name" [clearable]="false" [searchable]="true"
        [hasError]="isSubmitted && fg.get('lessonTopicId')?.invalid"
        [placeholder]="topicsIsLoading ? ('labels.loading'|translate) : ('planner.topic'|translate)"
        formControlName="lessonTopicId"></app-gray-select-input>
    </ng-container>

    <ng-container *ngIf="mode === 'text'">
      <label class="fs-small fw-500 color-gray-500 mb-1">{{'planner.note'|translate}}</label>
      <app-gray-text-input
        [hasErr]="isSubmitted && fg.get('message')?.invalid"
        [placeholder]="'planner.note_placeholder'|translate"
        formControlName="message"></app-gray-text-input>
    </ng-container>

    <div class="form-errors mt-2" *ngIf="isSubmitted && fg.invalid">
      <p>{{'errors.required'|translate}}</p>
    </div>

    <app-gray-button
      class="d-block mt-3"
      type="submit" color="primary" [weight]="800" padding="p-2" customClass="fs-normal"
      [isLoading]="isLoading" [disabled]="isLoading"
      [text]="'buttons.save'|translate"></app-gray-button>
  </form>

</div>
